import type { Localized } from "../types.ts"

/** 한국어·일본어를 나란히 적는다. 문서마다 반복되는 `{ ko: …, ja: … }` 를 줄인다. */
export const t = (ko: string, ja: string): Localized => ({ ko, ja })
